import { useDispatch, useSelector } from 'react-redux'
import { Icon } from '../../../../common/html/icon'
import { getFirstCellColumnStyle, hasCollapse } from '../helper'
import {
  close,
  open,
  selectCollapseInfoById,
  selectDataById,
} from '../store/slice'

const MIN_LEVEL = 5

const FirstCellColumn = ({ rowId, isDynamicReport }) => {
  const dispatch = useDispatch()

  const collapseInfo = useSelector(selectCollapseInfoById(rowId))
  const dataById = useSelector(selectDataById)

  const { name, level, isOpen, childrenIds } = collapseInfo
  const hasCollapseIcon = hasCollapse(dataById, childrenIds)
  const isShowCollapseIcon =
    level !== MIN_LEVEL && hasCollapseIcon && !isDynamicReport

  const onCollapse = () => {
    if (!isShowCollapseIcon) return
    isOpen
      ? dispatch(close({ rowId, childrenIds }))
      : dispatch(open({ rowId, childrenIds }))
  }

  return (
    <div
      style={getFirstCellColumnStyle(level, isDynamicReport)}
      onClick={onCollapse}
      className={`${isShowCollapseIcon && 'cursorPointer'}`}
    >
      {isShowCollapseIcon && (
        <Icon
          style={{ fontSize: 8, marginRight: 8 }}
          className={`${isOpen ? 'icon-caret-bottom' : 'icon-caret-right'}`}
        />
      )}
      <span>{name}</span>
    </div>
  )
}

export default FirstCellColumn
